import { render, staticRenderFns } from "./checkStudent.vue?vue&type=template&id=f0287d10&scoped=true"
import script from "./checkStudent.vue?vue&type=script&lang=js"
export * from "./checkStudent.vue?vue&type=script&lang=js"
import style0 from "./checkStudent.vue?vue&type=style&index=0&id=f0287d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0287d10",
  null
  
)

export default component.exports